<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page_iii"></a><span class="bold">Free People, Free Markets</span></h1>
<p class="stitle"><span class="bold">Their Evolutionary Origins</span></p>
<p class="author"><span class="bold">by Ralph L. Bayrer</span></p>
<p class="pub"><img alt="image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?4ea95e4e